import React from 'react';
import { Button } from 'antd';
import { CopyOutlined } from '@ant-design/icons';
import { Section } from '../../../components';
import useApiKey from '../../../hooks/useApiKey';
import withUser from '../../../withUser';
import MenuAdminLayout from '../../../components/users/MenuAdminLayout';

const TeamApiKey = ({ teams, userTeam }) => {
  const { teamApiKey } = useApiKey(teams, userTeam);
  const copyKeyToClipboard = () => navigator.clipboard.writeText(teamApiKey);

  return (
    <MenuAdminLayout
      title="Clé API de l'équipe"
      description="La clé API de l’équipe permettant de récupérer les différentes offres"
    >
      <Section
        title="Clé d'API de mon équipe"
        actions={(
          <Button
            onClick={copyKeyToClipboard}
            icon={<CopyOutlined />}
            size="large"
          >
            Copier la clé
          </Button>
        )}
      >
        <div className="break-all p-4 rounded text-flexi-grey bg-flexi-select-active">{teamApiKey}</div>
      </Section>
    </MenuAdminLayout>
  );
};

export default withUser(TeamApiKey);
